<template>
  <div class="themed-bg min-h-screen p-4 pb-20">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <div>
        <h2 class="text-2xl font-bold">Reports & Analytics</h2>
        <p class="themed-text-secondary">Data-driven insights for better decisions</p>
      </div>
      <ThemeToggle />
    </div>

    <!-- Functional Reports -->
    <FunctionalReports />
  </div>
</template>

<script setup>
import ThemeToggle from '@/components/ThemeToggle.vue'
import FunctionalReports from '@/components/FunctionalReports.vue'
</script>
